function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameCardboxTemplate = require('./game-cardbox.template');

/**
 * CardBox is mainly a tool to display a full size image of a game card (with detailed text instructions).
 * It works together with HUD and gameTemplate to allow players to click on cards in order to play them.
 * Cardbox actions are added to a register through addCardType, where a css class (that appears in HUD or Log or wherever)
 * is associated with a (name) and (callback function). Hovering over the css-class element will trigger the cardbox to display
 * and clicking on it will trigger the action in the callback.
 * Many games use .card (or .showcard) as target css classes. Remember to call attachCardEvents after refreshing the DOM.
 *
 * skip_card_prompt is a flag that allows cardbox to directly enact the action upon clicking on the target element.
 * Set the flag to 0 to bring up a confirmation window before instantiating the action.
 *
 */
var GameCardbox = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param app - the Saito application
   * @param mod - the game module
   */
  function GameCardbox(app, mod) {
    _classCallCheck(this, GameCardbox);
    this.app = app;
    this.game_mod = mod;
    this.cardbox_lock = 0; // 1 = mouseout does not remove popup
    this.show_exit_button = true;
    this.skip_card_prompt = 1; // 1 = don't prompt for action, just execute
    this.card_types = []; // associative array of css / text / callback
    this.current = null;
    this.callback = null;
  }

  /**
   * Adds cardbox to the DOM if it doesn't already exist (div elements start in display=none state)
   */
  return _createClass(GameCardbox, [{
    key: "render",
    value: function render() {
      if (!this.game_mod.browser_active) {
        return;
      }
      this.game_mod.useCardbox = 1;
      if (!document.getElementById('game-cardbox')) {
        this.app.browser.addElementToDom(GameCardboxTemplate());
        document.getElementById('game-cardbox').style.zIndex = -10; //push behind
      }
    }

    /**
     * Doesnt' do anything
     * Normally we would put the events here, but it is more clear to use a different function
     * because we often add/subtract card types or change the callback associated with the card
     */
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      console.log("For the Saito Cardbox, don't use attachEvents, use attachCardEvents");
    }

    /**
     * Cycles through property card_types (stored by method this.addCardType)
     * to associate mouse hover and click behavior on different css classes in the DOM
     */
  }, {
    key: "attachCardboxEvents",
    value: function attachCardboxEvents() {
      this.attachCardEvents();
    }
  }, {
    key: "attachCardEvents",
    value: function attachCardEvents() {
      var _this = this;
      try {
        this.render();
        var _loop = function _loop() {
          var card_css = _this.card_types[i].css;
          var card_action = _this.card_types[i].action;
          var card_callback = _this.card_types[i].mycallback;
          Array.from(document.getElementsByClassName(card_css)).forEach(function (card) {
            card.onmouseover = function (e) {
              try {
                if (_this.cardbox_lock !== 1) {
                  document.querySelector('.game-cardbox').style.pointerEvents = 'none';
                  _this.show(e.currentTarget.id);
                }
              } catch (err) {
                console.error(err);
              }
            };
            card.onmouseout = function (e) {
              try {
                _this.hide(); //cardbox_lock condition tested in hide
              } catch (err) {
                console.error(err);
              }
            };
            var xpos, ypos;
            if (card.classList.contains('noclick')) {
              return;
            }
            card.onmousedown = function (e) {
              xpos = e.clientX;
              ypos = e.clientY;
            };
            card.onmouseup = function (e) {
              if (Math.abs(xpos - e.clientX) > 4) {
                return;
              }
              if (Math.abs(ypos - e.clientY) > 4) {
                return;
              }
              if (_this.cardbox_lock === 1 && _this.current == e.currentTarget.id) {
                _this.hide(1); //cardbox_lock condition tested in hide
              } else {
                _this.cardbox_lock = 1; //toggle lock
                _this.current = e.currentTarget.id;
                try {
                  // lock so mouse can hover on cardbox
                  document.querySelector('.game-cardbox').style.pointerEvents = 'unset';
                } catch (err) {}
                var invoke_cb = card_action ? _this.callback || card_callback : card_callback;
                _this.show(e.currentTarget.id, card_action, invoke_cb);
              }
            };
          });
        };
        for (var i = 0; i < this.card_types.length; i++) {
          _loop();
        }

        //
        // force-close card popup
        //
        if (document.getElementById('cardbox-exit')) {
          var cardbox_exit_btn = document.getElementById('cardbox-exit');
          cardbox_exit_btn.onclick = function (e) {
            _this.hide(1);
          };
        }
      } catch (err) {
        console.error(err);
      }
    }
  }, {
    key: "detachCardEvents",
    value: function detachCardEvents() {
      try {
        for (var i = 0; i < this.card_types.length; i++) {
          var card_css = this.card_types[i].css;
          Array.from(document.getElementsByClassName(card_css)).forEach(function (card) {
            card.onmouseover = null;
            card.onmouseout = null;
            card.onmousedown = null;
            card.onmouseup = null;
          });
        }
      } catch (err) {
        console.err(err);
      }
    }

    /**
     * Displays the card's html in the DOM
     * @param card - the DOM element that triggered the cardbox
     * @param html - an html representation of the card image
     * @param action {text} - if provided, gives users a button to click on to execute action of the card
     * @param mycallback - if provided, is the function that executes the action of the card, passes "card" (DOM element) as a parameter
     */
  }, {
    key: "showCardboxHTML",
    value: function () {
      var _showCardboxHTML = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(card, html) {
        var _this2 = this;
        var action,
          mycallback,
          cbc,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              action = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : '';
              mycallback = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : null;
              if (!(!html || html.indexOf('noncard') > -1 || html.indexOf('nocard') > -1)) {
                _context2.n = 3;
                break;
              }
              if (!(mycallback != null)) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return mycallback(card);
            case 1:
              this.hide(1);
            case 2:
              return _context2.a(2);
            case 3:
              if (!((this.skip_card_prompt == 1 || !action) && mycallback !== null)) {
                _context2.n = 5;
                break;
              }
              _context2.n = 4;
              return mycallback(card);
            case 4:
              this.hide(1);
              return _context2.a(2);
            case 5:
              //Make everything else visible and overlay it on top of anything else happening on the screen
              document.getElementById('game-cardbox').style.zIndex = 250;
              document.getElementById('game-cardbox').style.display = 'block';
              document.getElementById('cardbox-card').style.display = 'block';
              document.getElementById('cardbox-card').innerHTML = html;

              //
              // if the cardbox is smaller than the card, we try to fix
              // so that the buttons and the exit button will be more
              // reasonably positioned on screen
              //
              try {
                cbc = document.getElementById('cardbox-card');
                if (parseInt(cbc.style.width) > 0) {
                  document.getElementById('game-cardbox').style.width = cbc.style.width;
                }
              } catch (err) {
                console.log('Error resizing cardbox');
              }

              //Create a single option menu for users to click to confirm playing "action"
              if (action) {
                this.cardbox_lock = 1;
                document.getElementById('cardbox-menu').style.display = 'block';
                document.getElementById('cardbox-menu').innerHTML = action;
                document.getElementById('cardbox-menu').onclick = /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
                    return _regenerator().w(function (_context) {
                      while (1) switch (_context.n) {
                        case 0:
                          if (!(mycallback != null)) {
                            _context.n = 1;
                            break;
                          }
                          _context.n = 1;
                          return mycallback(card);
                        case 1:
                          _this2.hide(1);
                        case 2:
                          return _context.a(2);
                      }
                    }, _callee);
                  }));
                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }();
              }

              //If we locked the display (on), include the exit button to close
              if (this.cardbox_lock == 1 && this.show_exit_button) {
                document.getElementById('cardbox-exit').style.display = 'block';
                document.getElementById('cardbox-exit-background').style.display = 'block';
              }
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function showCardboxHTML(_x, _x2) {
        return _showCardboxHTML.apply(this, arguments);
      }
      return showCardboxHTML;
    }()
    /**
     * Will query the game module for an image of the given card
     * and render it in the DOM. Will store the card in cardbox array of cards
     * @param card {DOM element}  id of the DOM element triggering the cardbox
     * @param action {text}
     * @param mycallback - an optional callback function
     */
  }, {
    key: "show",
    value: function show(card) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var mycallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (!card) {
        return;
      }
      var html = this.game_mod.returnCardImage(card);
      this.showCardboxHTML(card, html, action, mycallback);
    }

    /**
     * Hides the cardbox if it is not locked or if a force signal is sent
     * @param force {int 0,1} - will force the cardbox to close/hide even if it is in lock condition
     */
  }, {
    key: "hide",
    value: function hide() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      try {
        if (this.cardbox_lock === 1 && force === 0) {
          return;
        }
        var selectors = ['game-cardbox', 'cardbox-card', 'cardbox-menu', 'cardbox-exit', 'cardbox-exit-background'];
        for (var _i = 0, _selectors = selectors; _i < _selectors.length; _i++) {
          var id = _selectors[_i];
          if (document.getElementById(id)) {
            document.getElementById(id).style.display = 'none';
          }
        }
        if (document.getElementById('game-cardbox')) {
          document.getElementById('game-cardbox').style.zIndex = -10;
        }
        this.cardbox_lock = 0;
        this.current = null;
      } catch (err) {
        console.error(err);
      }
    }

    /**
     * Clear all Cardbox events and reset the card_types array
     */
  }, {
    key: "disable",
    value: function disable() {
      for (var i = 0; i < this.card_types.length; i++) {
        var card_css = this.card_types[i].css;
        Array.from(document.getElementsByClassName(card_css)).forEach(function (card) {
          card.onmouseover = null;
          card.onmouseout = null;
          card.onmousedown = null;
          card.onmouseup = null;
        });
      }
      this.card_types = [];
    }
  }, {
    key: "bindCallback",
    value: function bindCallback(callback) {
      this.callback = callback;
    }

    /**
     * A "card" is a triplicate of a css class name, a textual description of an action associated with the card, and a callback functon to be called if the card is selected
     * This function adds a triplicate to the class method so that subsequent calls to attachCardEvents
     */
  }, {
    key: "addCardType",
    value: function addCardType(css_name, action_text, mycallback) {
      var hover = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      for (var i = 0; i < this.card_types.length; i++) {
        if (this.card_types[i].css === css_name) {
          return;
        }
      }
      this.card_types.push({
        css: css_name,
        action: action_text,
        mycallback: mycallback,
        hover: hover
      });
    }
  }, {
    key: "removeCardType",
    value: function removeCardType(css_name) {
      this.detachCardEvents();
      for (var i = this.card_types.length - 1; i >= 0; i--) {
        if (this.card_types[i].css == css_name) {
          this.card_types.splice(i, 1);
        }
      }
      this.attachCardEvents();
    }
  }, {
    key: "makeDraggable",
    value: function makeDraggable() {
      this.app.browser.makeDraggable('game-cardbox', 'game-cardbox', true);
    }
  }]);
}();
module.exports = GameCardbox;